import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: 20,
  },
  '& .MuiDialogActions-root': {
    padding: 10,
  },
}));
